import { connect } from 'react-redux';
import { deleteGroup, startUpdateGroup, updateGroup } from '../../../actions/authorization';
import { getAuthorizationGroups, getMyPermissions } from '../../../reducers/analyticsApp';
import GroupsTablePane from '../../../components/authorization/groups/GroupsTablePane';
import { staticPermissions } from '../../../constants/authorization';

const mapStateToProps = (state) => ({
  groups: getAuthorizationGroups(state),
  hasPermission: getMyPermissions(state).has(staticPermissions.AUTHORIZATION_MANAGE),
});

export default connect(mapStateToProps, {
  onAdd: startUpdateGroup,
  onUpdate: startUpdateGroup,
  onDelete: deleteGroup,
  onRestore: updateGroup,
})(GroupsTablePane);
